import { __exports as EAN_UPC } from "./index164.js";
import { __require as requireEAN13 } from "./index165.js";
import { __require as requireEAN8 } from "./index166.js";
import { __require as requireEAN5 } from "./index167.js";
import { __require as requireEAN2 } from "./index168.js";
import { __require as requireUPC } from "./index169.js";
import { __require as requireUPCE } from "./index170.js";
var hasRequiredEAN_UPC;
function requireEAN_UPC() {
  if (hasRequiredEAN_UPC) return EAN_UPC;
  hasRequiredEAN_UPC = 1;
  Object.defineProperty(EAN_UPC, "__esModule", {
    value: true
  });
  EAN_UPC.UPCE = EAN_UPC.UPC = EAN_UPC.EAN2 = EAN_UPC.EAN5 = EAN_UPC.EAN8 = EAN_UPC.EAN13 = void 0;
  var _EAN = requireEAN13();
  var _EAN2 = _interopRequireDefault(_EAN);
  var _EAN3 = requireEAN8();
  var _EAN4 = _interopRequireDefault(_EAN3);
  var _EAN5 = requireEAN5();
  var _EAN6 = _interopRequireDefault(_EAN5);
  var _EAN7 = requireEAN2();
  var _EAN8 = _interopRequireDefault(_EAN7);
  var _UPC = requireUPC();
  var _UPC2 = _interopRequireDefault(_UPC);
  var _UPCE = requireUPCE();
  var _UPCE2 = _interopRequireDefault(_UPCE);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  EAN_UPC.EAN13 = _EAN2.default;
  EAN_UPC.EAN8 = _EAN4.default;
  EAN_UPC.EAN5 = _EAN6.default;
  EAN_UPC.EAN2 = _EAN8.default;
  EAN_UPC.UPC = _UPC2.default;
  EAN_UPC.UPCE = _UPCE2.default;
  return EAN_UPC;
}
export {
  requireEAN_UPC as __require
};
//# sourceMappingURL=index138.js.map
